export const ADD_NEW_ADDRESS = "ADD_NEW_ADDRESS";
export const GET_ALL_ADDRESSES = "GET_ALL_ADDRESSES";
export const GET_ADDRESS = "GET_ADDRESS";
export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
